// @flow
import React from 'react';
import { useSelector } from 'react-redux';

import Badge from 'app/common/ui/Badge';

import selectItemsNumber from './selectItemsNumber';


type Props = {
  [string]: mixed,
}

const CardNumberBadge = (props: Props) => {
  const cartItemsNumber = useSelector(selectItemsNumber);

  if (!cartItemsNumber) return null;

  return (
    // $FlowFixMe
    <Badge {...props} value={cartItemsNumber} />
  );
};

export default CardNumberBadge;
